import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-freight-rate-types',
  templateUrl: './freight-rate-types.component.html',
  styleUrls: ['./freight-rate-types.component.css']
})
export class FreightRateTypesComponent implements OnInit {
    public itemsListRateTypes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadFreightRateTypes(): Promise<void> {
        this.itemsListRateTypes = await this.datatask.Post(1536);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'freightratetype':
                this.stateService?.go('freightratetype', { freightratetype_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadFreightRateTypes();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('freightRateTypes', {
//        templateUrl: 'views/components/views/freightRateTypes/freightRateTypes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'freightRateTypesService', function (stateService, freightRateTypesService) {
//            const vm = this;

//            vm.model = {
//                itemsListRateTypes: []
//            };

//            let loadFreightRateTypes = function () {
//                freightRateTypesService.listFreightRateTypes().then(function (list) {
//                    angular.copy(list, vm.model.itemsListRateTypes);
//                });
//            };

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'freightratetype':
//                        go({ freightratetype_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadFreightRateTypes();
//            };
//        }]
//    });
//})();
